var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useStore } from "@context/store";
import { useUI } from "@context/ui";
import { Button } from "@components/ui";
import { DAYS } from "@constants/index";
import { formatDate } from "@utils/index";
var ListItemTimeEntriesSkeleton = function () {
    return (_jsxs("div", __assign({ className: "animate-pulse opacity-40 py-4" }, { children: [_jsx("div", { className: "h-7 w-32  float-left mr-2 mb-2 bg-decent rounded" }, void 0),
            _jsx("div", { className: "h-7 w-32 float-left mr-2 mb-2 bg-decent rounded" }, void 0),
            _jsx("div", { className: "clear-both" }, void 0),
            _jsx("div", { className: "h-7 w-28  float-left mr-2 mb-2 bg-decent rounded" }, void 0)] }), void 0));
};
var TimeEntries = function (_a) {
    var timeEntries = _a.timeEntries, onClick = _a.onClick, activeIndex = _a.activeIndex;
    return (_jsx(_Fragment, { children: timeEntries.map(function (_a, index) {
            var startTime = _a.startTime, endTime = _a.endTime, available = _a.available;
            return (_jsx(Button, __assign({ className: "float-left mr-2 mb-2", disabled: !available, active: activeIndex === index, onClick: onClick.bind(_this, index) }, { children: startTime + "-" + endTime }), "time-entry-" + index));
        }) }, void 0));
};
var TimeEntryPicker = function (_a) {
    var slots = _a.slots;
    var nextStep = useUI().nextStep;
    var setTimeEntry = useStore().setTimeEntry;
    var _b = useState(-1), dateIndex = _b[0], setDateIndex = _b[1];
    var _c = useState(-1), timeEntryIndex = _c[0], setTimeEntryIndex = _c[1];
    var getFirstAvailableIndex = function (entries) {
        for (var i = 0; i < entries.length; i++) {
            if (entries[i].available)
                return i;
        }
        return -1;
    };
    var handleSelectDate = function (_dateIndex) {
        setDateIndex(_dateIndex);
        var _timeEntryIndex = getFirstAvailableIndex(slots[_dateIndex].timeEntries);
        setTimeEntryIndex(_timeEntryIndex);
    };
    var handleTimeEntrySelect = function (index) {
        setTimeEntryIndex(index);
    };
    var handleConfirm = function () {
        if (slots[dateIndex] && slots[dateIndex].timeEntries[timeEntryIndex]) {
            var _a = slots[dateIndex], date = _a.date, timeEntries_1 = _a.timeEntries;
            var _b = timeEntries_1[timeEntryIndex], id = _b.id, startTime = _b.startTime, endTime = _b.endTime, variantId = _b.variantId;
            setTimeEntry({ id: id, startTime: startTime, endTime: endTime, date: date, variantId: variantId });
            nextStep();
        }
    };
    var renderDate = function (date) {
        if (date) {
            return (_jsxs("div", { children: [DAYS[date.getDay()], _jsx("br", {}, void 0), formatDate(date)] }, void 0));
        }
        return "N/A";
    };
    useEffect(function () {
        var _dateIndex = getFirstAvailableIndex(slots);
        setDateIndex(_dateIndex);
        var _timeEntryIndex = getFirstAvailableIndex(slots[_dateIndex].timeEntries);
        setTimeEntryIndex(_timeEntryIndex);
    }, []);
    if (dateIndex < 0) {
        return _jsx(ListItemTimeEntriesSkeleton, {}, void 0);
    }
    var _d = slots[dateIndex], timeEntries = _d.timeEntries, available = _d.available;
    var isDisabled = !(available && timeEntries[timeEntryIndex].available);
    var buttonClasses = "float-left mr-2 mb-2";
    return (_jsxs(_Fragment, { children: [slots.map(function (_a, index) {
                var date = _a.date, available = _a.available;
                return (_jsx(Button, __assign({ className: buttonClasses, disabled: !available, active: index === dateIndex, onClick: handleSelectDate.bind(_this, index) }, { children: renderDate(date) }), "date-slot-" + index));
            }),
            _jsx("div", { className: "clear-both" }, void 0),
            timeEntries && (_jsx(TimeEntries, { timeEntries: timeEntries, activeIndex: timeEntryIndex, onClick: handleTimeEntrySelect }, void 0)),
            _jsx("div", { className: "clear-both" }, void 0),
            _jsx(Button, __assign({ primary: true, className: buttonClasses, disabled: isDisabled, onClick: handleConfirm }, { children: "Confirm" }), void 0)] }, void 0));
};
export default TimeEntryPicker;
